import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const TitleUpdater = () => {
    const location = useLocation();

    useEffect(() => {
        const path = location.pathname.split('/')[1];
        const formattedPathName = path.charAt(0).toUpperCase() + path.slice(1).toLowerCase();

        if (formattedPathName) {
            document.title = `${formattedPathName} - Acumen Translation Hub`;
        }
    }, [location]);

    return null;
};

export default TitleUpdater;
